import type { IPilotage } from "./types";
import { MAX_LIVES } from "./data";
import { input } from "shared";

export class Pilot implements IPilotage {
  readonly maxLifes = MAX_LIVES;
  private _controlUp = false;
  private _controlDown = false;

  get controlUp(): boolean {
    return this._controlUp;
  }

  get controlDown(): boolean {
    return this._controlDown;
  }

  update(_pos: { x: number; y: number }): void {
    this._controlUp = input.actionPressed || input.pollGamepad();
    this._controlDown = input.actionReleased;
  }
}
